/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Asset properties that can be used for sorting. Sort by name uses the `customName` field if it exists,
 * otherwise it uses the `name` field.
 * Attribute names containing `energySource` return values that are coalesced between corresponding battery and fuel attributes.
 *
 * Following `enums` are deprecated:
 * - ownershipType (Use ownershipTypeCode and/or ownershipTypeName instead).
 *
 */
export var AssetPropertiesForSorting;
(function (AssetPropertiesForSorting) {
    AssetPropertiesForSorting["ID"] = "id";
    AssetPropertiesForSorting["NAME"] = "name";
    AssetPropertiesForSorting["SERIAL_NUMBER"] = "serialNumber";
    AssetPropertiesForSorting["MAKE"] = "make";
    AssetPropertiesForSorting["MAKE_CODE"] = "makeCode";
    AssetPropertiesForSorting["MAKE_NAME"] = "makeName";
    AssetPropertiesForSorting["MODEL"] = "model";
    AssetPropertiesForSorting["PRODUCT_FAMILY_NAME"] = "productFamilyName";
    AssetPropertiesForSorting["PRODUCT_FAMILY_CODE"] = "productFamilyCode";
    AssetPropertiesForSorting["MODEL_YEAR"] = "modelYear";
    AssetPropertiesForSorting["TYPE_CODE"] = "typeCode";
    AssetPropertiesForSorting["STATUS_NAME"] = "statusName";
    AssetPropertiesForSorting["STATUS_CODE"] = "statusCode";
    AssetPropertiesForSorting["STATUS_LAST_REPORTED_TIME"] = "statusLastReportedTime";
    AssetPropertiesForSorting["CUSTOMER_DEFINED_STATUS_NAME"] = "customerDefinedStatusName";
    AssetPropertiesForSorting["CUSTOMER_DEFINED_STATUS_CODE"] = "customerDefinedStatusCode";
    AssetPropertiesForSorting["SUBSCRIPTION_STATUS_CODE"] = "subscriptionStatusCode";
    AssetPropertiesForSorting["SUBSCRIPTION_STATUS_NAME"] = "subscriptionStatusName";
    AssetPropertiesForSorting["OWNERSHIP_TYPE"] = "ownershipType";
    AssetPropertiesForSorting["OWNERSHIP_TYPE_CODE"] = "ownershipTypeCode";
    AssetPropertiesForSorting["OWNERSHIP_TYPE_NAME"] = "ownershipTypeName";
    AssetPropertiesForSorting["DEVICE_TYPE"] = "deviceType";
    AssetPropertiesForSorting["DEVICE_STATUS_NAME"] = "deviceStatusName";
    AssetPropertiesForSorting["DEVICE_STATUS_CODE"] = "deviceStatusCode";
    AssetPropertiesForSorting["DEVICE_STATUS_LAST_REPORTED_TIME"] = "deviceStatusLastReportedTime";
    AssetPropertiesForSorting["GENERATOR_STATUS_CODE"] = "generatorStatusCode";
    AssetPropertiesForSorting["GENERATOR_STATUS_NAME"] = "generatorStatusName";
    AssetPropertiesForSorting["GENERATOR_STATUS_LAST_REPORTED_TIME"] = "generatorStatusLastReportedTime";
    AssetPropertiesForSorting["GENERATOR_DERIVED_STATUS_CODE"] = "generatorDerivedStatusCode";
    AssetPropertiesForSorting["GENERATOR_DERIVED_STATUS_NAME"] = "generatorDerivedStatusName";
    AssetPropertiesForSorting["GENERATOR_DERIVED_STATUS_LAST_REPORTED_TIME"] = "generatorDerivedStatusLastReportedTime";
    AssetPropertiesForSorting["LOCATION_ADDRESS"] = "locationAddress";
    AssetPropertiesForSorting["LOCATION_LAST_REPORTED_TIME"] = "locationLastReportedTime";
    AssetPropertiesForSorting["CONTAINS_LOCATION"] = "containsLocation";
    AssetPropertiesForSorting["ODOMETER_READING"] = "odometerReading";
    AssetPropertiesForSorting["ODOMETER_READING_LAST_REPORTED_TIME"] = "odometerReadingLastReportedTime";
    AssetPropertiesForSorting["ODOMETER_READING_DESIRED_SETTING_VALUE"] = "odometerReadingDesiredSettingValue";
    AssetPropertiesForSorting["ODOMETER_READING_DESIRED_SETTING_UPDATED_TIME"] = "odometerReadingDesiredSettingUpdatedTime";
    AssetPropertiesForSorting["HOURS_READING"] = "hoursReading";
    AssetPropertiesForSorting["HOURS_READING_LAST_REPORTED_TIME"] = "hoursReadingLastReportedTime";
    AssetPropertiesForSorting["HOURS_READING_DESIRED_SETTING_VALUE"] = "hoursReadingDesiredSettingValue";
    AssetPropertiesForSorting["HOURS_READING_DESIRED_SETTING_UPDATED_TIME"] = "hoursReadingDesiredSettingUpdatedTime";
    AssetPropertiesForSorting["FUEL_LEVEL"] = "fuelLevel";
    AssetPropertiesForSorting["FUEL_LEVEL_LAST_REPORTED_TIME"] = "fuelLevelLastReportedTime";
    AssetPropertiesForSorting["DEF_LEVEL"] = "defLevel";
    AssetPropertiesForSorting["DEF_LEVEL_LAST_REPORTED_TIME"] = "defLevelLastReportedTime";
    AssetPropertiesForSorting["LIFE_TIME_FUEL_CONSUMED"] = "lifeTimeFuelConsumed";
    AssetPropertiesForSorting["LIFE_TIME_FUEL_CONSUMED_LAST_REPORTED_TIME"] = "lifeTimeFuelConsumedLastReportedTime";
    AssetPropertiesForSorting["LIFE_TIME_DEF_CONSUMED"] = "lifeTimeDefConsumed";
    AssetPropertiesForSorting["LIFE_TIME_DEF_CONSUMED_LAST_REPORTED_TIME"] = "lifeTimeDefConsumedLastReportedTime";
    AssetPropertiesForSorting["LIFE_TIME_ENERGY_GENERATED"] = "lifeTimeEnergyGenerated";
    AssetPropertiesForSorting["LIFE_TIME_ENERGY_GENERATED_LAST_REPORTED_TIME"] = "lifeTimeEnergyGeneratedLastReportedTime";
    AssetPropertiesForSorting["BATTERY_CHARGE_LEVEL"] = "batteryChargeLevel";
    AssetPropertiesForSorting["BATTERY_CHARGE_LEVEL_LAST_REPORTED_TIME"] = "batteryChargeLevelLastReportedTime";
    AssetPropertiesForSorting["BATTERY_STATUS_NAME"] = "batteryStatusName";
    AssetPropertiesForSorting["BATTERY_STATUS_CODE"] = "batteryStatusCode";
    AssetPropertiesForSorting["BATTERY_STATUS_LAST_REPORTED_TIME"] = "batteryStatusLastReportedTime";
    AssetPropertiesForSorting["BATTERY_STATUS_CHARGE_TIME_TO_HUNDRED_PERCENT_READING"] = "batteryStatusChargeTimeToHundredPercentReading";
    AssetPropertiesForSorting["BATTERY_STATUS_ESTIMATED_WORKING_TIME_REMAINING_READING"] = "batteryStatusEstimatedWorkingTimeRemainingReading";
    AssetPropertiesForSorting["BATTERY_STATUS_STATE_OF_HEALTH"] = "batteryStatusStateOfHealth";
    AssetPropertiesForSorting["LIFETIME_BATTERY_CONSUMED_READING"] = "lifetimeBatteryConsumedReading";
    AssetPropertiesForSorting["LIFETIME_BATTERY_CONSUMED_LAST_REPORTED_TIME"] = "lifetimeBatteryConsumedLastReportedTime";
    AssetPropertiesForSorting["ENERGY_SOURCE_LEVEL_READING"] = "energySourceLevelReading";
    AssetPropertiesForSorting["ENERGY_SOURCE_LEVEL_LAST_REPORTED_TIME"] = "energySourceLevelLastReportedTime";
    AssetPropertiesForSorting["ENERGY_SOURCE_STATUS_NAME"] = "energySourceStatusName";
    AssetPropertiesForSorting["ENERGY_SOURCE_STATUS_CODE"] = "energySourceStatusCode";
    AssetPropertiesForSorting["ENERGY_SOURCE_STATUS_LAST_REPORTED_TIME"] = "energySourceStatusLastReportedTime";
    AssetPropertiesForSorting["LIFETIME_ENERGY_SOURCE_CONSUMED_READING"] = "lifetimeEnergySourceConsumedReading";
    AssetPropertiesForSorting["LIFETIME_ENERGY_SOURCE_CONSUMED_LAST_REPORTED_TIME"] = "lifetimeEnergySourceConsumedLastReportedTime";
    AssetPropertiesForSorting["UCID"] = "ucid";
    AssetPropertiesForSorting["UCID_NAME"] = "ucidName";
    AssetPropertiesForSorting["DCN"] = "dcn";
    AssetPropertiesForSorting["DCN_NAME"] = "dcnName";
    AssetPropertiesForSorting["DEALER_CODE"] = "dealerCode";
    AssetPropertiesForSorting["DEALER_NAME"] = "dealerName";
    AssetPropertiesForSorting["END_OF_DAY_DESIRED_SETTINGS_END_OF_DAY"] = "endOfDayDesiredSettingsEndOfDay";
    AssetPropertiesForSorting["END_OF_DAY_CURRENT_SETTINGS_END_OF_DAY"] = "endOfDayCurrentSettingsEndOfDay";
    AssetPropertiesForSorting["SUBSCRIPTION_NAME"] = "subscriptionName";
    AssetPropertiesForSorting["SUBSCRIPTION_NAME_INFO_CODE"] = "subscriptionNameInfoCode";
    AssetPropertiesForSorting["SUBSCRIPTION_NAME_INFO_NAME"] = "subscriptionNameInfoName";
    AssetPropertiesForSorting["SECURITY_STATUS"] = "securityStatus";
    AssetPropertiesForSorting["SECURITY_DESIRED_SETTING_VALUE"] = "securityDesiredSettingValue";
    AssetPropertiesForSorting["SECURITY_REQUEST_CREATION_TIME"] = "securityRequestCreationTime";
    AssetPropertiesForSorting["SECURITY_CONFIGURATION_STATUS"] = "securityConfigurationStatus";
    AssetPropertiesForSorting["PREFERRED_SERVICE_METER_READING"] = "preferredServiceMeterReading";
    AssetPropertiesForSorting["PREFERRED_SERVICE_METER_READING_TIME"] = "preferredServiceMeterReadingTime";
    AssetPropertiesForSorting["SOURCE"] = "source";
    AssetPropertiesForSorting["DATA_PROVIDER"] = "dataProvider";
    AssetPropertiesForSorting["ORG_CUSTOM_ATTRIBUTES_FIELD1"] = "orgCustomAttributesField1";
    AssetPropertiesForSorting["ORG_CUSTOM_ATTRIBUTES_FIELD2"] = "orgCustomAttributesField2";
    AssetPropertiesForSorting["ORG_CUSTOM_ATTRIBUTES_FIELD3"] = "orgCustomAttributesField3";
    AssetPropertiesForSorting["ORG_CUSTOM_ATTRIBUTES_FIELD4"] = "orgCustomAttributesField4";
    AssetPropertiesForSorting["ORG_CUSTOM_ATTRIBUTES_FIELD5"] = "orgCustomAttributesField5";
    AssetPropertiesForSorting["ORG_CUSTOM_ATTRIBUTES_FIELD6"] = "orgCustomAttributesField6";
    AssetPropertiesForSorting["ORG_CUSTOM_ATTRIBUTES_FIELD7"] = "orgCustomAttributesField7";
    AssetPropertiesForSorting["ORG_CUSTOM_ATTRIBUTES_FIELD8"] = "orgCustomAttributesField8";
    AssetPropertiesForSorting["ORG_CUSTOM_ATTRIBUTES_FIELD9"] = "orgCustomAttributesField9";
    AssetPropertiesForSorting["ORG_CUSTOM_ATTRIBUTES_FIELD10"] = "orgCustomAttributesField10";
    AssetPropertiesForSorting["ORG_CUSTOM_ATTRIBUTES_FIELD11"] = "orgCustomAttributesField11";
    AssetPropertiesForSorting["ORG_CUSTOM_ATTRIBUTES_FIELD12"] = "orgCustomAttributesField12";
    AssetPropertiesForSorting["BRAND_CODE"] = "brandCode";
    AssetPropertiesForSorting["RENTAL_INFO_CONTRACT_ID"] = "rentalInfoContractId";
    AssetPropertiesForSorting["RENTAL_INFO_CONTRACT_START_DATE"] = "rentalInfoContractStartDate";
    AssetPropertiesForSorting["RENTAL_INFO_CONTRACT_END_DATE"] = "rentalInfoContractEndDate";
})(AssetPropertiesForSorting || (AssetPropertiesForSorting = {}));
